import { render, staticRenderFns } from "./events-log-list.vue?vue&type=template&id=2f91bb1b"
import script from "./events-log-list.vue?vue&type=script&lang=js"
export * from "./events-log-list.vue?vue&type=script&lang=js"
import style0 from "./events-log-list.vue?vue&type=style&index=0&id=2f91bb1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports